import { aboutContent } from '@/data/mock';
import usePageTitle from '@/hooks/usePageTitle';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AboutPage = () => {
  usePageTitle('About');
  return (
    <div>
      {/* Hero Section - Dark */}
      <section className="bg-brand-dark py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-3xl lg:text-4xl font-semibold text-white mb-6">
              About ElevateMN
            </h1>
            <p className="text-lg text-gray-400">
              Building stronger communities through mental health support.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-brand-light py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <h2 className="text-2xl font-semibold text-brand-dark mb-6">
              Our Mission
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {aboutContent.mission}
            </p>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <h2 className="text-2xl font-semibold text-brand-dark mb-6">
              Our Vision
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {aboutContent.vision}
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="bg-brand-light py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="text-2xl font-semibold text-brand-dark mb-12">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {aboutContent.values.map((value, index) => (
              <div key={index}>
                <h3 className="text-xl font-semibold text-brand-dark mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Community in Action */}
      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <p className="text-center text-brand-gold font-semibold tracking-wide mb-3">You are not alone.</p>
          <p className="text-center text-gray-500 text-sm mb-10">Our community in action</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="col-span-2 row-span-2">
              <img src="/images/site/gallery01.jpg" alt="Elevated Escape group" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <img src="/images/site/gallery02.jpg" alt="Live music" className="w-full h-full object-cover" loading="lazy" />
            <img src="/images/site/gallery03.jpg" alt="Nature trail" className="w-full h-full object-cover" loading="lazy" />
            <img src="/images/site/gallery04.jpg" alt="Holiday gala" className="w-full h-full object-cover" loading="lazy" />
            <img src="/images/site/gallery05.jpg" alt="Camp hangout" className="w-full h-full object-cover" loading="lazy" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
